import { FC } from 'react';
import { OptimizelyProvider } from '~/contexts/OptimizelyContext';
import { useOptimizelyProject } from '~/adapters/optimizely/optimizelyProjects';
import { useOptimizelyQueryParam } from '~/pages/Flags/UseOptimizelyQueryParam';
import { PWC } from '~/adapters/typescript/propsWithChildren';

export const FeatureFlagsProjectContext: FC<PWC> = ({ children }) => {
    const projectName = useOptimizelyQueryParam();
    const optimizely = useOptimizelyProject(projectName);

    return (
        <OptimizelyProvider optimizely={optimizely} name={projectName} useFullLayoutLoader={false}>
            {children}
        </OptimizelyProvider>
    );
};
